import gql from 'graphql-tag';

export default gql`
  query getBuyerCustomerContactRequests($ids: [Int!]!) {
    getBuyerCustomerContactRequests(ids: $ids) {
      id
      taxBuyerName
      taxCode
      taxEmail
      taxAddress
    }
  }
`;
